import { render, staticRenderFns } from "./RepairEstimateSideCard.vue?vue&type=template&id=0bdca5c6&"
import script from "./RepairEstimateSideCard.vue?vue&type=script&lang=ts&"
export * from "./RepairEstimateSideCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports